import axios from 'axios'
import { Customer } from '../../models/customer'
import { API_ROUTES } from '../routes'

export const updateCustomer = async (customerId: string, customerData: any) => {
  return axios.patch<Customer>(API_ROUTES.CUSTOMER + customerId, customerData)
}
